"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useVideoThumbnail = require("./useVideoThumbnail");
Object.keys(_useVideoThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useVideoThumbnail[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useVideoThumbnail[key];
    }
  });
});